export default __webpack_public_path__ + "static/identity-mock-m3-2678db35bf79f5ca0d1912c02156015a.png";